<common-icon-progress-bar [steps]="steps"></common-icon-progress-bar>
<ng-container *ngIf="showNotificationData">
  <div class="my-3 bb-light"></div>
  <div class="d-flex paragraph-text">
    <i class="icon-checkmark text-green mr-2 fs-19"></i>
    <div class="mr-auto">{{ notificationTitle[transportationLoad.status] }}</div>
    <div class="text-grey d-none d-md-block">{{ notificationDate }}</div>
  </div>
  <div class="text-grey paragraph-text d-md-none">{{ notificationDate }}</div>
</ng-container>
<div class="my-3 bb-light"></div>
<div *ngIf="showTransportationData" class="mt-4">
  <div class="container">
    <div class="row">
      <div *ngIf="showDropOffInfo && quotedStep.completed" class="col-md-4 br-light mt-4 mt-md-0">
        <div class="bold">Dropoff Date</div>
        <div class="paragraph-text text-grey mt-2">
          {{ transportationLoad.scheduledDroppoff | date }}
        </div>
        <div class="bold mt-3">Dropoff Location</div>
        <div class="paragraph-text text-grey mt-2" [innerHtml]="transportationLoad.dropoff | location"></div>
      </div>

      <div *ngIf="!showDropOffInfo" class="col-md-4 br-light mt-4 mt-md-0">
        <div class="bold">Pickup Date</div>
        <div class="paragraph-text text-grey mt-2">
          {{ transportationLoad.scheduledPickup | date }}
        </div>
        <div class="bold mt-3">Pickup Location</div>
        <div class="paragraph-text text-grey mt-2" [innerHtml]="transportationLoad.pickup | location"></div>
      </div>

      <div class="col-md-4 mt-4 mt-md-0" *ngIf="quotedStep.completed" [class.br-light]="quotedStep.completed">
        <div class="bold">Carrier information</div>

        <div class="paragraph-text text-grey">
          <div class="mt-2">{{ transportationLoad.carrier.name }}</div>
          <div class="mt-2">{{ transportationLoad.carrier.phoneNumber }}</div>
          <div class="mt-2">
            <a href="mailto:{{ transportationLoad.carrier.email }}">{{ transportationLoad.carrier.email }}</a>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-4 mt-md-0" *ngIf="(quotedStep.active || quotedStep.completed) && showQuotedPrice">
        <div class="bold">Price</div>
        <div class="paragraph-text text-grey mt-2">
          {{ transportationLoad.quotePrice | currency }}
        </div>
      </div>
    </div>
  </div>
</div>
